import { Component, Input, OnChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { GravatarService } from 'app/core/gravatar.service';

/**
 * Circular avatar for a visitor/profile. Shows the gravatar photo when the
 * email has one; otherwise a person icon in a single consistent style:
 * filled when identified (has an email), outlined when anonymous.
 */
@Component({
  selector: 'app-person-avatar',
  templateUrl: './person-avatar.component.html',
  styleUrls: ['./person-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PersonAvatarComponent implements OnChanges {
  /** Email used to resolve the gravatar; empty renders the anonymous icon. */
  @Input() email: string | undefined = '';
  /** Rendered size (px) for both the photo and the fallback icons. */
  @Input() diameter = 18;

  protected url = '';
  protected failed = false;
  protected fallbackIcon = 'person_outline';

  private readonly gravatarService = inject(GravatarService);

  ngOnChanges() {
    this.url = '';
    this.failed = false;
    const email = this.email?.trim();
    this.fallbackIcon = email ? 'person' : 'person_outline';
    if (!email) {
      return;
    }
    this.gravatarService.getUrlForEmail(email).then((url) => {
      // Ignore late resolutions after the input changed
      if (this.email?.trim() === email) {
        this.url = url;
      }
    });
  }
}
